import React from 'react';
export function PainPoints() {
  return <section className="py-20 md:py-28 px-4" data-id="element-306">
      <div className="max-w-3xl mx-auto text-center" data-id="element-307">
        <h2 className="text-4xl md:text-6xl font-extrabold mb-8 tracking-tight leading-tight" data-id="element-308">
          DOMINGO A LA NOCHE. <br data-id="element-309" />
          <span className="text-zinc-500" data-id="element-310">NO SABÉS QUÉ DAR MAÑANA.</span>
        </h2>

        <div className="space-y-5 text-lg md:text-2xl text-zinc-300 leading-relaxed font-medium" data-id="element-311">
          <p data-id="element-312">
            Volvés a improvisar a último momento, buscando ideas en Instagram y
            repitiendo los mismos ejercicios de siempre.
          </p>
          <p data-id="element-313">
            El tiempo no alcanza, y armar una progresión coherente para todo el
            año parece imposible.
          </p>
          <p className="text-primary font-bold text-xl md:text-3xl pt-4" data-id="element-314">
            No es falta de capacidad. Es falta de un sistema.
          </p>
        </div>
      </div>
    </section>;
}